var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import { UtilsActions } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
import axios from "axios";
let UtilsModule = class UtilsModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
    }
    [_a = UtilsActions.IS_CNPJ](cnpj) {
        return new Promise(resolve => {
            let multiplicador1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            let multiplicador2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            let soma;
            let resto;
            let digito;
            let tempCnpj;
            cnpj = cnpj.trim();
            cnpj = cnpj.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
            if ((cnpj.length != 14)) {
                return false;
            }
            tempCnpj = cnpj.substr(0, 12);
            soma = 0;
            for (let i = 0; (i < 12); i++) {
                soma = (soma
                    + (Number(tempCnpj[i]) * multiplicador1[i]));
            }
            resto = (soma % 11);
            if ((resto < 2)) {
                resto = 0;
            }
            else {
                resto = (11 - resto);
            }
            digito = String(resto);
            tempCnpj = (tempCnpj + digito);
            soma = 0;
            for (let i = 0; (i < 13); i++) {
                soma = (soma
                    + (Number(tempCnpj[i]) * multiplicador2[i]));
            }
            resto = (soma % 11);
            if ((resto < 2)) {
                resto = 0;
            }
            else {
                resto = (11 - resto);
            }
            digito = (digito + String(resto));
            resolve(cnpj.endsWith(digito));
        });
    }
    [_b = UtilsActions.IS_CPF](cpf) {
        return new Promise(resolve => {
            let multiplicador1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
            let multiplicador2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
            let tempCpf;
            let digito;
            let soma;
            let resto;
            cpf = cpf.trim();
            cpf = cpf.replaceAll(".", "").replaceAll("-", "");
            if ((cpf.length != 11)) {
                return false;
            }
            tempCpf = cpf.substr(0, 9);
            soma = 0;
            for (let i = 0; (i < 9); i++) {
                soma = (soma
                    + (Number(tempCpf[i]) * multiplicador1[i]));
            }
            resto = (soma % 11);
            if ((resto < 2)) {
                resto = 0;
            }
            else {
                resto = (11 - resto);
            }
            digito = String(resto);
            tempCpf = (tempCpf + digito);
            soma = 0;
            for (let i = 0; (i < 10); i++) {
                soma = (soma + (Number(tempCpf[i]) * multiplicador2[i]));
            }
            resto = (soma % 11);
            if ((resto < 2)) {
                resto = 0;
            }
            else {
                resto = (11 - resto);
            }
            digito = (digito + String(resto));
            resolve(cpf.endsWith(digito));
        });
    }
    [_c = UtilsActions.IS_PIS](pis) {
        return new Promise(resolve => {
            let multiplicador = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            let soma;
            let resto;
            if ((pis.trim().length != 11)) {
                return false;
            }
            pis = pis.trim();
            pis = pis.replaceAll("-", "").replaceAll(".", "").PadLeft(11, '0');
            soma = 0;
            for (let i = 0; (i < 10); i++) {
                soma = (soma
                    + (Number(pis[i])) * multiplicador[i]);
            }
            resto = (soma % 11);
            if ((resto < 2)) {
                resto = 0;
            }
            else {
                resto = (11 - resto);
            }
            resolve(pis.endsWith(resto));
        });
    }
    [_d = UtilsActions.IS_RG](rg) {
        return new Promise(resolve => {
            rg = rg.replaceAll("-", "").replaceAll(".", "").replaceAll(",", "");
            if ((rg.length == 9)) {
                let n = new Array(8);
                n[0] = Number(rg.substr(0, 1));
                n[1] = Number(rg.substr(1, 1));
                n[2] = Number(rg.substr(2, 1));
                n[3] = Number(rg.substr(3, 1));
                n[4] = Number(rg.substr(4, 1));
                n[5] = Number(rg.substr(5, 1));
                n[6] = Number(rg.substr(6, 1));
                n[7] = Number(rg.substr(7, 1));
                n[8] = Number(rg.substr(8, 1));
                n[0] = (n[0] * 2);
                n[1] = (n[1] * 3);
                n[2] = (n[2] * 4);
                n[3] = (n[3] * 5);
                n[4] = (n[4] * 6);
                n[5] = (n[5] * 7);
                n[6] = (n[6] * 8);
                n[7] = (n[7] * 9);
                n[8] = (n[8] * 100);
                let somaFinal = n.reduce((a, b) => { return a + b; });
                if (somaFinal % 11 == 0) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            }
            else {
                resolve(false);
            }
        });
    }
    [_e = UtilsActions.IS_CNH](cnh) {
        return new Promise(resolve => {
            var CreateString = (val, count) => {
                var retorno = "";
                for (let i = 0; i < count; i++) {
                    retorno += val;
                }
                return retorno;
            };
            var validateCNH = (valor) => {
                let isValid = false;
                let cnh = valor;
                let firstChar = cnh[0];
                if (cnh.length == 11 && cnh != CreateString(firstChar, 11)) {
                    var dsc = 0;
                    var v = 0;
                    for (let i = 0, j = 9; i < 9; i++, j--) {
                        v += (Number(cnh[i].toString()) * j);
                    }
                    var vl1 = v % 11;
                    if (vl1 >= 10) {
                        vl1 = 0;
                        dsc = 2;
                    }
                    v = 0;
                    for (let i = 0, j = 1; i < 9; ++i, ++j) {
                        v += (Number(cnh[i].toString()) * j);
                    }
                    var x = v % 11;
                    var vl2 = (x >= 10) ? 0 : x - dsc;
                    isValid = vl1.toString() + vl2.toString() == cnh.substring(cnh.length - 2, cnh.length);
                }
                return isValid;
            };
            resolve(validateCNH(cnh));
        });
    }
    [_f = UtilsActions.GET_ADDRESS_BY_CEP](cep) {
        return new Promise(resolve => {
            axios.get(`https://viacep.com.br/ws/${cep}/json/`).then(res => {
                resolve(res.data);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UtilsModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UtilsModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UtilsModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UtilsModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UtilsModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UtilsModule.prototype, _f, null);
UtilsModule = __decorate([
    Module
], UtilsModule);
export default UtilsModule;
//# sourceMappingURL=UtilsModule.js.map